"use client";

import * as React from "react";
import {Box, Typography, Button, List, ListItem} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { HeaderNavProps } from "@/components/header/common/types";

type PrimaryNavigationProps = {
  headerNavProps: HeaderNavProps[];
  handleItemClick: (d: HeaderNavProps) => void;
  currentPrimaryNavItem: string;
  drawerOpen: boolean;
};

export default function PrimaryNavigation(props: PrimaryNavigationProps) {
  const {
    headerNavProps,
    handleItemClick,
    currentPrimaryNavItem,
    drawerOpen
  } = props;

  return (
    <Box id="primary-navigation" sx={{ display: "flex", paddingBottom: 1}}>
      <List
        sx={{
          display: "flex",
          flexDirection: "row",
          padding: 0
        }}
      >
        {headerNavProps.map((primaryNavItem) => {
          const hasSubNav = Array.isArray(primaryNavItem.fields.subNavList) && primaryNavItem.fields.subNavList.length > 0;
          return (
            <ListItem
              key={primaryNavItem.sys.id}
              data-testid={`primary-nav-item-${primaryNavItem.fields.title}`}
              sx={{
                padding: 0
              }}
            >
              <Button
                onClick={
                  hasSubNav
                    ? (
                      () => {
                        handleItemClick(primaryNavItem);
                      })
                    : undefined
                }
                size="large"
                component={hasSubNav ? "button" : "a"}
                href={hasSubNav ? undefined : primaryNavItem.fields.url}
                className="navPrimary"
                data-nav-level="primary"
                data-nav-label={primaryNavItem.fields.title}
                sx={{
                  textTransform: "capitalize",
                  color: "var(--isagent-nav-color)",
                  "&:hover, &.Mui-selected": {
                    backgroundColor: "transparent",
                    "& .MuiTypography-root": {
                      opacity: .8
                    }
                  }
                }}
              >
                <Typography
                  sx={{
                    color: "var(--isagent-nav-color)",
                    fontSize: "16px",
                    fontWeight: "600",
                    textWrap: "nowrap"
                  }}
                >
                  {primaryNavItem.fields.title}
                </Typography>
                {Array.isArray(primaryNavItem.fields.subNavList) && primaryNavItem.fields.subNavList.length > 0 && (
                  <KeyboardArrowDownIcon
                    sx={{
                      mr: "-0.6rem",
                      fontSize: "2.4rem",
                      fontWeight: "600",
                      transform: currentPrimaryNavItem === primaryNavItem.sys.id && drawerOpen
                        ? "rotate(-180deg)"
                        : "none",
                      transition: "transform 0.2s ease-in-out"
                    }}
                  />
                )}
              </Button>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
}
